import React from 'react';
import { useSelector } from 'react-redux';

import BalanceHeader from '../../components/balance-header/balance-header';
import { RootState } from '../../types';

interface BalanceHeaderContainerProps {
  isHideBalanceInformer?: boolean;
}

const BalanceHeaderContainer: React.FC<BalanceHeaderContainerProps> = ({
  isHideBalanceInformer,
}) => {
  const balance = useSelector((state: RootState) => state.balance);

  return (
    <BalanceHeader
      cfaValue={balance.data.info?.simpleTokenValue}
      hybridValue={balance.data.info?.hybridValue}
      isHideBalanceInformer={isHideBalanceInformer}
    />
  );
};

export default BalanceHeaderContainer;
